import client from './client';

export interface DevelopmentStage {
  id: string;
  name: string;
  stage: number;
}

export const getAllDevelopmentStages = async (): Promise<DevelopmentStage[]> => {
  const response = await client.get('/api/v1/development-stages/');
  return response.data;
};
